<template>
  <div class="login-page-container d-flex align-items-center justify-content-center min-vh-100 bg-light view-user-login">
    <div class="login-box" style="width: 100%; max-width: 400px;">
      <b-card class="shadow">
        <b-card-body>
          <div class="row">
            <div class="col-12 text-center mb-3">
              <img
                class="logo-login-img"
                src="@/assets/img/dentcloud-logo-darkblue.png"
              />
              <h3 class="logo-caption mt-2">
                <span class="">D</span>ent<span class="">C</span>loud
              </h3>
            </div>
          </div>
          <div v-if="isLogin">
            <div v-if="!isError && !isMissingAllowedConsent">
              <div v-if="missingAllowedScopes.length === 0">
                <div class="d-flex justify-content-center mb-1">
                  <b-avatar
                    :variant="user.contentId ? 'white' : 'info'"
                    :text="abbreviation"
                    alt="User Image"
                    size="4rem"
                    :src="user.profile_url"
                  ></b-avatar>
                </div>
                <h4 class="text-muted text-center">
                  {{ `${user.first_name_th} ${user.last_name_en}` }}
                </h4>

                <div class="col-12">
                  <button
                    class="btn btn-success btn-block btn-sm"
                    @click="requestAuthorizationCode"
                  >
                    เข้าสู่ระบบด้วย DentCloud
                  </button>
                  <button
                    class="btn btn-primary btn-block btn-sm"
                    @click="signInWithOtherAccount"
                  >
                    ใช้บัญชีอื่น
                  </button>
                </div>
              </div>
              <div v-else>
                <div
                  class="d-flex justify-content-center mb-1 align-items-center"
                >
                  <b-avatar
                    :variant="user.contentId ? 'white' : 'info'"
                    :text="abbreviation"
                    alt="User Image"
                    size="2rem"
                    :src="user.profile_url"
                  ></b-avatar>
                  <p class="text-muted text-center m-0 ml-1">
                    {{ `${user.email}` }}
                  </p>
                </div>

                <h5 class="text-muted text-center mt-4">
                  แอพพลิเคชั่น
                  <b class="text-primary">{{ this.clientName }}</b>
                  ต้องการเข้าถึง:
                </h5>
                <ul>
                  <li
                    v-for="(scope, index) in missingAllowedScopes"
                    :key="index"
                  >
                    <b>{{ scope }}</b> {{ scopeDescription[scope].description }}
                  </li>
                </ul>
                <div class="container">
                  <div class="row">
                    <div class="col">
                      <button
                        class="btn btn-primary"
                        @click="() => giveConsentToAccessUserResrource(false)"
                      >
                        ยกเลิก
                      </button>
                    </div>
                    <div class="col text-right">
                      <button
                        class="btn btn-success"
                        @click="() => giveConsentToAccessUserResrource(true)"
                      >
                        ยินยอม
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="isMissingAllowedConsent">
              <h5 class="text-muted text-center">
                คุณไม่อณุญาตให้แอพพลิเคชั่น
                <b class="text-primary">{{ this.clientName }}</b>
                ทำการเข้าถึง:
              </h5>
              <ul>
                <li v-for="(scope, index) in missingAllowedScopes" :key="index">
                  <b>{{ scope }}</b> {{ scopeDescription[scope].description }}
                </li>
              </ul>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-success btn-block btn-sm"
                    @click="
                      () =>
                        this.redirectToURI(
                          `missing_consent`,
                          `missing user consent`
                        )
                    "
                  >
                    ย้อนกลับ
                  </button>
                </div>
              </div>
            </div>

            <div v-else-if="isError">
              <h5 class="text-muted text-center">
                {{ ERROR_MESSAGES.OAUTH_SYSTEM_ERROR }}
              </h5>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-12">
                <div
                  class="alert alert-warning alert-dismissible fade show"
                  role="alert"
                  v-if="statusLogin"
                >
                  กรุณาตรวจสอบ อีเมลล์ หรือ รหัสผ่าน ให้ถูกต้อง
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="setStatusLogin"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
            <b-form v-if="!mfaPending" @submit.prevent="authenticate">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="email">อีเมลล์</label>
                    <div class="input-group">
                      <input
                        id="login-input-login-view"
                        class="form-control form-control-sm"
                        v-model.trim="loginForm.username"
                        required
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">
                          <span class="fas fa-user"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>รหัสผ่าน</label>
                    <div class="input-group">
                      <input
                        id="password-input-login-view"
                        type="password"
                        class="form-control form-control-sm"
                        v-model="loginForm.password"
                        required
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">
                          <span class="fas fa-lock"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-success btn-block btn-sm"
                  >
                    เข้าสู่ระบบด้วย DentCloud
                  </button>
                </div>
              </div>
            </b-form>

            <div v-else>
              <div class="row">
                <div class="col-12 text-center mb-3">
                  <h5 class="mb-1">ยืนยันตัวตนสองชั้น</h5>
                  <p class="text-muted small mb-0">
                    กรอกรหัส 6 หลักจากแอปยืนยันตัวตนของคุณ
                  </p>
                </div>
              </div>

              <b-form @submit.prevent="submitOAuthMfa" autocomplete="off">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label v-if="!oauthRecoveryMode" for="oauth-mfa-code-input"
                        >รหัส 6 หลัก</label
                      >
                      <input
                        v-if="!oauthRecoveryMode"
                        id="oauth-mfa-code-input"
                        ref="oauthMfaCodeInput"
                        data-testid="oauth-mfa-code"
                        class="form-control form-control-sm text-center"
                        style="letter-spacing: 4px;"
                        inputmode="numeric"
                        maxlength="6"
                        autocomplete="one-time-code"
                        :value="oauthMfaCode"
                        @input="onOAuthMfaCodeInput($event.target.value)"
                        :disabled="isLoading"
                      />
                      <label v-else for="oauth-mfa-recovery-input"
                        >รหัสสำรอง</label
                      >
                      <input
                        v-if="oauthRecoveryMode"
                        id="oauth-mfa-recovery-input"
                        data-testid="oauth-mfa-recovery-code"
                        class="form-control form-control-sm"
                        v-model.trim="oauthRecoveryCode"
                        autocomplete="off"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <button
                      type="submit"
                      data-testid="oauth-mfa-submit"
                      class="btn btn-success btn-block btn-sm"
                      :disabled="
                        isLoading ||
                        (oauthRecoveryMode
                          ? !oauthRecoveryCode
                          : oauthMfaCode.length !== 6)
                      "
                    >
                      ยืนยัน
                    </button>
                  </div>
                </div>
              </b-form>

              <div class="row">
                <div class="col-12 text-center mt-2">
                  <a
                    href="#"
                    data-testid="oauth-mfa-use-recovery"
                    @click.prevent="toggleOAuthRecoveryMode"
                    >{{
                      oauthRecoveryMode
                        ? "ใช้รหัส 6 หลักแทน"
                        : "ใช้รหัสสำรองแทน"
                    }}</a
                  >
                </div>
              </div>
            </div>

            <div class="row" v-if="!mfaPending">
              <div class="col-12">
                <span class="mb-0 mt-3 ml-auto">
                  <a href="/user/forgotpassword" class="text-center"
                    >ลืมรหัสผ่าน?</a
                  >
                </span>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <Loading v-if="isLoading"></Loading>
    <Dialog ref="Dialog"></Dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "@/components/Loading";
import Dialog from "@/components/modal/Dialog";
import axios from "axios";
import { eventBus } from "@/main";
import { ERROR_MESSAGES } from "@/constants/errorMessages";

const HOST = process.env.VUE_APP_OAUTH_BASE_URL;

export default {
  name: "Login",
  components: {
    Loading,
    Dialog
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      isMissingAllowedConsent: false,
      loginForm: {
        username: "",
        password: "",
        rememberMe: false
      },

      statusLogin: false,
      query: {},
      isLogin: false,
      user: {},
      client_id: "",
      scope: "",
      redirect_uri: "",
      response_type: "",
      code: "",
      clientDetail: null,
      scopeDescription: {
        profile: {
          description: "เข้าถึงข้อมูลโปรไฟล์บัญชี DentCloud ของคุณ"
        }
      },
      missingAllowedScopes: [],
      ERROR_MESSAGES, // Make error messages available in template
      // OAuth MFA challenge state
      mfaPending: false,
      oauthMfaCode: "",
      oauthRecoveryMode: false,
      oauthRecoveryCode: ""
    };
  },
  created() {},
  async mounted() {
    try {
      this.query = this.$route.query;
      const { client_id, scope, redirect_uri, response_type } = this.query;
      this.client_id = client_id;
      this.scope = scope;
      this.redirect_uri = redirect_uri;
      this.response_type = response_type;

      await this.getUserProfile();
    } catch (err) {
      console.error(err);
    }
  },
  computed: {
    ...mapGetters({
      getLoginApiStatus: "moduleAuth/getLoginApiStatus",
      viewFile: "moduleContent/viewFile"
    }),
    abbreviation() {
      if (this.user?.firstNameEn || this.user?.lastNameEn) {
        var firstName = "";
        var lastName = "";
        if (this.user?.firstNameEn) {
          firstName = this.user.firstNameEn.charAt(0);
        }
        if (this.user?.lastNameEn) {
          lastName = this.user.lastNameEn.charAt(0);
        }
        return `${firstName}${lastName}`;
      } else {
        return null;
      }
    }
  },
  methods: {
    ...mapActions({
      login: "moduleUser/login",
      actionLoginApi: "moduleAuth/loginApi"
    }),

    /**
     *
     * @param {string} error
     * @param {string} errorDesc
     */
    redirectToURI(error, errorDesc) {
      const url = new URL(this.redirect_uri);
      url.search = new URLSearchParams({
        error_desc: errorDesc,
        error: error
      });
      window.location.replace(url);
    },

    /**
     *
     * @param {boolean} allow
     */
    async giveConsentToAccessUserResrource(allow) {
      this.isLoading = true;
      try {
        const response = await axios.post(
          `${HOST}/o/oauth2/consent`,
          {
            allow
          },
          {
            params: {
              client_id: this.client_id
            }
          }
        );
        switch (response.status) {
          case 200:
            this.missingAllowedScopes = [];
            break;
          default:
            this.isMissingAllowedConsent = true;
            break;
        }
      } catch (error) {
        eventBus.$emit("apiError", error);
        this.isError = true;
      } finally {
        this.isLoading = false;
      }
    },

    async getCurrentClientDetail() {
      try {
        const response = await axios.get(`${HOST}/o/oauth2/client`, {
          params: {
            client_id: this.client_id
          }
        });
        this.clientDetail = response.data;
        this.clientName = response.data.client_name;
      } catch (error) {
        eventBus.$emit("apiError", error);
        this.isError = true;
      }
    },

    async getUserResourcesAccessConsent() {
      try {
        const response = await axios.get(`${HOST}/o/oauth2/consent`, {
          params: {
            client_id: this.client_id
          }
        });
        const { data } = response;
        switch (response.status) {
          case 200:
            this.missingAllowedScopes = data.scope;
            return;
          default:
            return;
        }
      } catch (error) {
        eventBus.$emit("apiError", error);
        this.isError = true;
      }
    },

    async getUserProfile() {
      this.isLoading = true;
      try {
        const response = await axios.get(`${HOST}/o/account`);
        if (response.status !== 200) {
          return;
        }

        await Promise.all([
          this.getUserResourcesAccessConsent(),
          this.getCurrentClientDetail()
        ]);

        this.user = response.data;
        this.isLogin = true;
      } catch (error) {
        // do nothing
      } finally {
        this.isLoading = false;
      }
    },

    async authenticate() {
      this.isLoading = true;
      try {
        const response = await axios.post(`${HOST}/o/authenticate`, {
          username: this.loginForm.username,
          password: this.loginForm.password
        });

        if (response.data && response.data.mfaRequired) {
          // Enrolled user: switch to the code-entry state; do not log in yet.
          this.loginForm.password = "";
          this.mfaPending = true;
          this.focusOAuthMfaCodeInput();
        } else if (response.data && response.data.mfaEnrollmentRequired) {
          // The clinic requires MFA and this account has none. Enforcement is
          // identical to /api/login — the session is NOT authenticated — but
          // there is no in-place enrollment here: the enrollment endpoints live
          // in the main API, so the user sets up on the portal and returns.
          this.loginForm.password = "";
          this.showDialogToast(
            "warning",
            "คลินิกของคุณกำหนดให้ต้องยืนยันตัวตน 2 ชั้น กรุณาเข้าสู่ระบบที่พอร์ทัลเพื่อตั้งค่าก่อน"
          );
        } else {
          await this.getUserProfile();
        }
      } catch (error) {
        if (error.response?.status === 401) {
          // Handle authentication errors with specific message
          this.showDialogToast("danger", ERROR_MESSAGES.INVALID_CREDENTIALS);
        } else if (error.response?.status === 423) {
          this.showDialogToast(
            "danger",
            "บัญชีถูกล็อกชั่วคราวเนื่องจากกรอกรหัสผ่านผิดหลายครั้ง กรุณาลองใหม่ภายหลัง"
          );
        } else {
          // Use global error system for other errors
          eventBus.$emit("apiError", error);
        }
      } finally {
        this.isLoading = false;
      }
    },

    async submitOAuthMfa() {
      this.isLoading = true;
      try {
        const body = this.oauthRecoveryMode
          ? { recoveryCode: this.oauthRecoveryCode }
          : { code: this.oauthMfaCode };

        await axios.post(`${HOST}/o/authenticate/mfa`, body);

        this.backToOAuthLogin();
        await this.getUserProfile();
      } catch (error) {
        if (error.response?.status === 401) {
          this.showDialogToast("danger", "รหัสไม่ถูกต้อง กรุณาลองใหม่");
          this.oauthMfaCode = "";
          this.oauthRecoveryCode = "";
        } else if (error.response?.status === 423) {
          this.showDialogToast(
            "danger",
            "ยืนยันตัวตนล้มเหลวหลายครั้ง กรุณาลองใหม่ภายหลัง"
          );
        } else {
          eventBus.$emit("apiError", error);
        }
      } finally {
        this.isLoading = false;
      }
    },

    toggleOAuthRecoveryMode() {
      this.oauthRecoveryMode = !this.oauthRecoveryMode;
      this.oauthMfaCode = "";
      this.oauthRecoveryCode = "";

      if (!this.oauthRecoveryMode) {
        this.focusOAuthMfaCodeInput();
      }
    },

    onOAuthMfaCodeInput(value) {
      this.oauthMfaCode = (value || "").replace(/\D/g, "").slice(0, 6);
    },

    focusOAuthMfaCodeInput() {
      this.$nextTick(() => {
        if (this.$refs.oauthMfaCodeInput) {
          this.$refs.oauthMfaCodeInput.focus();
        }
      });
    },

    backToOAuthLogin() {
      this.mfaPending = false;
      this.oauthMfaCode = "";
      this.oauthRecoveryCode = "";
      this.oauthRecoveryMode = false;
    },

    signInWithOtherAccount() {
      this.isLogin = false;
      this.loginForm = {
        username: "",
        password: "",
        rememberMe: false
      };
    },

    async requestAuthorizationCode() {
      this.isLoading = true;
      try {
        const { client_id, scope, redirect_uri, response_type } = this.query;
        const response = await axios.get(
          `${HOST}/o/oauth2/authorization-code`,
          {
            params: {
              client_id,
              scope,
              redirect_uri,
              response_type
            }
          }
        );
        const { code } = response.data;
        this.code = code;

        this.redirectWithAuthorizationCode();

        return;
      } catch (err) {
        eventBus.$emit("apiError", err);
        this.isError = true;
      } finally {
        this.isLoading = false;
      }
    },
    setStatusLogin() {
      this.statusLogin = false;
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    redirectWithAuthorizationCode() {
      const url = new URL(this.query.redirect_uri);
      url.search = new URLSearchParams({
        grant_type: "code",
        code: this.code
      });
      window.location.replace(url.toString());
    }
  }
};
</script>

<style>
.logo-caption {
  font-family: "Noto Sans Thai";
  font-size: 32px;
  font-weight: 900;
  color: #1d5d8e;
}
.logo-login-img {
  width: 50%;
}
</style>
